export default __webpack_public_path__ + "static/media/cloud-2@3x.037ab479.png";